// extracted by css-extract-rspack-plugin
export default {"cls1":"StatelessWorkCardsUpsellModal-styles-cls1_tS3","cls2":"StatelessWorkCardsUpsellModal-styles-cls2_NvD StatelessWorkCardsUpsellModal-styles-cls1_tS3"};